import t from 'tcomb';
import {DemographicInfo} from "./DemographicInfo";

export const Users = t.struct({
    categoryWiseScore: t.struct({
        a: t.String,
        b: t.String,
        c: t.String,
        d: t.String,
        e: t.String,
        f: t.String,
    }),
    code: t.String,
    demographicInformation: DemographicInfo,
    id: t.String
}, 'Users');

export const getDefaultUsers = () => null;


